import React from "react";

export type ThumbUpProps = {
  /**
   * Width of the logo
   * if you overrides width + height, 'size' props will be ignored
   */
  width?: number;
  /**
   * Height of the logo
   * if you overrides width + height, 'size' props will be ignored
   */
  height?: number;
  /**
   * Choose between them value
   * @default black
   */
  color?: string;
  /**
   * The size of the logo
   * small: 122*46 | medium: 155*60 | large: 217*83
   * @default medium
   */
  size?: "small" | "medium" | "large";
};

const sizes = {
  small: {
    width: 34,
    height: 34,
  },
  medium: {
    width: 34,
    height: 34,
  },
  large: {
    width: 34,
    height: 34,
  },
};

export const ThumbUp = React.forwardRef<SVGSVGElement, ThumbUpProps>(
  (props, ref) => {
    const { size = "medium", width, height, color = "black" } = props;
    const svgSize = width && height ? { width, height } : sizes[size];
    return (
      <svg
        ref={ref}
        width={svgSize.width}
        height={svgSize.height}
        viewBox="0 0 34 34"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.23593 28.5125C3.44373 28.5125 2.80469 29.1656 2.80469 29.9531C2.80469 31.8422 5.67033 31.8515 5.67033 29.9531C5.67033 29.1656 5.03125 28.5125 4.23597 28.5125H4.23593Z"
          fill={color}
        />
        <path
          d="M7.4275 16.8344V32.1656H2.1711V16.8344H7.4275ZM18.4039 13.6548C18.232 14.1657 18.6133 14.7032 19.1617 14.7032H30.5493C32.2227 14.7032 32.2274 17.3016 30.5493 17.3016H23.7729C22.7245 17.3016 22.7245 18.8985 23.7729 18.8985H30.5493C32.2227 18.8985 32.2274 21.497 30.5493 21.497L23.7729 21.4985C22.7245 21.4985 22.7245 23.0954 23.7729 23.0954H30.5493C32.2227 23.0954 32.2274 25.6938 30.5493 25.6938L23.7729 25.6954C22.7245 25.6954 22.7245 27.2923 23.7729 27.2923H30.5493C32.2852 27.2923 32.1618 29.9626 30.5446 29.8954C29.0758 29.8095 27.6446 30.2673 25.9806 30.8063C22.7291 31.8501 18.4898 33.2141 11.4994 30.8829C10.5979 30.4345 9.64941 30.1767 9.03377 30.0391L9.08221 18.8283C11.715 17.3127 14.7714 9.15793 14.7806 9.13473C14.8665 8.91129 15.1619 4.63793 14.9947 2.29713C14.9462 1.63933 15.9634 2.11588 16.2338 2.25963C20.2493 5.55807 18.576 12.93 18.4041 13.6548L18.4039 13.6548ZM1.3711 15.2376C0.932019 15.2376 0.574219 15.5954 0.574219 16.0344V32.9624C0.574219 33.4015 0.932031 33.7593 1.3711 33.7593H8.2291C9.24002 33.7593 9.02598 32.5343 9.02598 31.6702C10.151 31.9609 10.2994 32.1562 10.9525 32.3765C21.9773 36.0671 26.8697 31.1749 30.4509 31.4843C32.7728 31.6843 34.5525 28.5421 32.5822 26.5483V26.553L32.5197 26.4952C33.7072 25.3311 33.7166 23.4998 32.5822 22.3516L32.5197 22.2984C33.7072 21.1297 33.7166 19.3031 32.5822 18.1548L32.5197 18.097C33.7072 16.9329 33.7166 15.1017 32.5822 13.9578C32.0572 13.4281 31.3369 13.1047 30.5509 13.1047L20.1401 13.1063C20.5792 10.6547 21.2464 4.27506 17.212 0.998262C16.9542 0.774826 13.1356 -1.24706 13.4027 2.40918C13.5464 4.38262 13.298 7.99838 13.2495 8.67958C12.9152 9.55146 10.6417 15.3984 9.02473 17.0436C9.02473 16.3577 9.2013 15.2358 8.22785 15.2358L1.3711 15.2376Z"
          fill={color}
        />
      </svg>
    );
  }
);

ThumbUp.displayName = "ThumbUp";
